import { motion } from "framer-motion";
import { Mail, Clock } from "lucide-react";


export default function CTA() {
  return (
    <motion.section
      initial={{ y: 30, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="mt-20 bg-gradient-to-br from-purple-50 to-blue-50 rounded-3xl md:p-14 text-center"
    >
      <h2 className="text-3xl md:text-4xl text-foreground mb-6">
        Ready to start a project?
      </h2>

      <p className="text-muted-foreground text-lg mb-8 max-w-2xl mx-auto">
        I'd love to learn more about your project and discuss how we can work 
        together to create something amazing. Let's schedule a call to chat!
      </p>

      <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
        <a
          href="mailto:jane@example.com?subject=Project Inquiry"
          className="inline-flex items-center space-x-2 bg-foreground text-background px-8 py-4 rounded-xl hover:bg-foreground/90 transition-colors"
        >
          <Mail className="w-4 h-4" />
          <span>Send me an email</span>
        </a>

        <a
          href="https://calendly.com/janedoe"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center space-x-2 border border-border px-8 py-4 rounded-xl hover:bg-accent transition-colors"
        >
          <Clock className="w-4 h-4" />
          <span>Schedule a call</span>
        </a>
      </div>

      <p className="text-muted-foreground text-sm mt-6">
        Typical response time: 24-48 hours
      </p>
    </motion.section>
  );
}
